import React from 'react';
import { Loader } from '@groupelacentrale/contact-storybook';
import styles from './LoadingPage.module.scss';

export const LoadingPage = (): React.ReactElement => {
  return (
    <div className={styles.loading}>
      <Loader />
    </div>
  );
};
